import type { FC } from "react"
import { memo } from "react"

import { useRecoilValue } from "recoil"

import { BrochurePanel } from "./BrochurePanel"
import { Panel, StudioPanels } from "./Panel"
import { PotentialPanels } from "./PotentialPanels"
import {
  activePanelIndex,
  isSnappingOnState,
  panelIndex,
} from "../../../state/elements/panels"
import { toolState } from "../../../state/tool"

const Panels_Internal: FC<{
  onlyShowActive?: boolean
  isOnBrochure?: boolean
}> = ({ onlyShowActive, isOnBrochure }) => {
  const allPanelIds = useRecoilValue(panelIndex)
  const activePanelIds = useRecoilValue(activePanelIndex)
  const tool = useRecoilValue(toolState)
  const ids = onlyShowActive ? activePanelIds : allPanelIds
  const snappingIsOn = useRecoilValue(isSnappingOnState)

  return (
    <>
      {isOnBrochure ? (
        <>
          {ids.map((id) => (
            <BrochurePanel key={id} id={id} />
          ))}
        </>
      ) : (
        <>
          {[`PanelCreatorPortrait`, `PanelCreatorLandscape`].includes(tool) &&
            snappingIsOn &&
            ids.map((id) => (
              <PotentialPanels key={id + `potential panels`} id={id} />
            ))}
          <StudioPanels ids={ids} />
        </>
      )}
    </>
  )
}

export const Panels = memo(Panels_Internal)
